import { render, staticRenderFns } from "./skin-settings.vue?vue&type=template&id=598102da"
import script from "./skin-settings.vue?vue&type=script&lang=js"
export * from "./skin-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports